import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as TelecallerActions from "../../../store/actions/Telecaller";
import { FlexContainer } from "../../../constants/assets/containers";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { isMobile } from "../../../utils";

const TelecallerInputBar = (props) => {
  const { telecallerList, handleSubmitClick, nextPage, getTelecallerProfiles } =
    props;

  const handleSelect = (e) => {
    handleSubmitClick(e);
  };

  const handleNextPage = async (existingList) => {
    let result = existingList;
    const pageRequest = {
      page_number: nextPage,
    };
    await getTelecallerProfiles({}, pageRequest).then((res) => {
      if (res && res.telecallers) {
        const filtered_result = res.telecallers.filter(
          (item) => item.present_in_lms
        );
        result = [...result, ...filtered_result];
      }
    });
    return result;
  };

  return (
    <InputBar>
      <PaginatedReactDropdown
        options={telecallerList}
        labelKey="email"
        valueKey="auth_detail_id"
        handleSelect={handleSelect}
        placeholder="Select Telecaller"
        showPagination
        nextPage={nextPage}
        showCross={false}
        handleNextPage={handleNextPage}
        id="telecallerDropdown"
      />
    </InputBar>
  );
};

const InputBar = styled(FlexContainer)`
  max-width: 100%;
  margin-left: auto;
  margin-right: 0;
  .sushi-dropdown {
    width: 100%;
    margin-bottom: unset;
    & > div > div {
      padding: 1.4rem 2rem;
    }
  }
  .customDropdown {
    margin-bottom: unset;
  }
`;

const mapStateToProps = (state) => {
  const { Telecaller } = state;
  return {
    nextPage: Telecaller.nextPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTelecallerProfiles: bindActionCreators(
      TelecallerActions.getTelecallerProfiles,
      dispatch
    ),
    resetState: bindActionCreators(TelecallerActions.resetState, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TelecallerInputBar);
